module.exports = __webpack_public_path__ + "static/media/pen.b49bf1bd.svg";